import _Vue from "vue";
import {Route} from "vue-router";
import {storeModules} from "../../store";
import {cacheClear , cacheUpdateOrCreate , getCacheKeyByModule} from "../../utils/util";
import {LocalforageWrapper} from "../../utils/localforage-wrapper";
import CACHE_KEY from "../../common/cache-key.constant";
import tippy from "tippy.js";

const MultipleTabPlugin = {
	install(Vue: typeof _Vue , options?: Object | {}) {
		Vue.prototype.$removeRoute = function (route: Route, index?: number): Promise<any> {
			let vm = this as any;
			let routeIndex = index ? index : getRouteIndex(route, vm).next().value;
			if (routeIndex > -1 ) {
				return vm.$store.dispatch(`${storeModules.Common}/deleteCommonVisitedViews` , {route: route, index: routeIndex})
					.then(() => {
						vm.$cacheClear(route);
						return Promise.resolve(route);
					});
			}
			return Promise.resolve(route);
		};
		
		Vue.prototype.$routeVisible = function (route: Route):Promise<Boolean> {
			return Promise.resolve(getRouteIndex(route, this).next().value > -1);
		};
		
		Vue.prototype.$cacheUpdateOrCreate = function (route: Route, object: any, module?: number): Promise<any> {
			return cacheUpdateOrCreate(route.fullPath, object, module);
		};
		
		Vue.prototype.$getCacheByKey = function(route: Route, type?: string) {
			let {cacheKey, cacheKeyOrigin, cacheKeyCondition, cacheKeyFilter, cacheKeyFilterParameter} = getCacheKeyByModule(route.fullPath);
			switch (type) {
				case CACHE_KEY.CACHE_ORIGIN:
					return LocalforageWrapper.getItem(cacheKeyOrigin);
				case CACHE_KEY.CACHE_CONDITION:
					return LocalforageWrapper.getItem(cacheKeyCondition);
				case CACHE_KEY.CACHE_FILTER:
					return LocalforageWrapper.getItem(cacheKeyFilter);
				case CACHE_KEY.CACHE_FILTER_PARAMETER:
					return LocalforageWrapper.getItem(cacheKeyFilterParameter);
				default:
					return LocalforageWrapper.getItem(cacheKey);
			}
		};
		
		Vue.prototype.$setCacheByKey = function(route: Route, object: any, type?: string) {
			let {cacheKey, cacheKeyOrigin, cacheKeyCondition, cacheKeyFilter, cacheKeyFilterParameter} = getCacheKeyByModule(route.fullPath);
			switch (type) {
				case CACHE_KEY.CACHE_ORIGIN:
					return LocalforageWrapper.setItem(cacheKeyOrigin, object);
				case CACHE_KEY.CACHE_CONDITION:
					return LocalforageWrapper.setItem(cacheKeyCondition, object);
				case CACHE_KEY.CACHE_FILTER:
					return LocalforageWrapper.setItem(cacheKeyFilter, object);
				case CACHE_KEY.CACHE_FILTER_PARAMETER:
					return LocalforageWrapper.setItem(cacheKeyFilterParameter, object);
				default:
					return LocalforageWrapper.setItem(cacheKey, object);
			}
		};
		
		Vue.prototype.$cacheClear = function (route: Route) {
			return cacheClear(route.fullPath);
		};
		
		Vue.prototype.$setOrRemoveCurrentFavourite = function (route: Route, module: string): Promise<any> {
			let vm = this as any;
			let index = getRouteIndex(route, vm).next().value;
			let {cacheKeyFilterParameter} = getCacheKeyByModule(route.fullPath);
			if (index > -1) {
				return LocalforageWrapper.setItem(cacheKeyFilterParameter, vm.$store.getters[`${storeModules.Favourites}/getCurrentFavourite`]);
			} else {
				return LocalforageWrapper.removeItem(cacheKeyFilterParameter);
			}
		};
		
		Vue.prototype.$setOrRemoveData = function(route: Route, object: any, type?: string, module?: number): Promise<any> {
			let vm = this as any;
			let index = getRouteIndex(route, vm).next().value;
			let {cacheKey, cacheKeyOrigin, cacheKeyCondition, cacheKeyFilter, cacheKeyFilterParameter} = getCacheKeyByModule(route.fullPath);
			let key: string = null;
			switch (type) {
				case CACHE_KEY.CACHE_ORIGIN:
					key = cacheKeyOrigin;
					break;
				case CACHE_KEY.CACHE_CONDITION:
					key = cacheKeyCondition;
					break;
				case CACHE_KEY.CACHE_FILTER:
					key = cacheKeyFilter;
					break;
				case CACHE_KEY.CACHE_FILTER_PARAMETER:
					key = cacheKeyFilterParameter;
					object = vm.$store.getters[`${storeModules.Favourites}/getCurrentFavourite`];
					break;
				default:
					key = cacheKey;
			}
			return setOrRemove(index, key, object);
		};
		
		Vue.prototype.$setOrRemoveSearchParameter = function (route: Route, object: Object, module: string): Promise<any> {
			let vm = this as any;
			let index = getRouteIndex(route, vm).next().value;
			let {cacheKeyCondition} = getCacheKeyByModule(route.fullPath);
			if (index > -1) {
				return LocalforageWrapper.setItem(cacheKeyCondition, object);
			} else {
				return LocalforageWrapper.removeItem(cacheKeyCondition);
			}
		};
		
		Vue.prototype.$updateCommonVisitedView = function (route: Route, tabName?: string, module?: string) {
			let vm = this as any;
			if (tabName) route.params.tabName = tabName;
			vm.$store.commit(`${storeModules.Common}/updateCommonVisitedViews`, route);
		};
		
		Vue.prototype.$cacheReset = function (module?: string) {
			return LocalforageWrapper.clear();
		};
		
		Vue.prototype.$closeTippy = function (): Promise<any> {
			return Promise.resolve(tippy.hideAllPoppers());
		};
		
		function setOrRemove(index: number, cacheKey: string, object?: Object): Promise<any> {
			if (index > -1) {
				return LocalforageWrapper.setItem(cacheKey, object);
			} else {
				return LocalforageWrapper.removeItem(cacheKey);
			}
		}
		function *getRouteIndex(route: Route, vm: any) {
			yield vm.$store.getters[`${storeModules.Common}/getCommonVisitedViews`].findIndex((item) => item.fullPath.replace(/\/$/g , "") === route.fullPath.replace(/\/$/g , ""));
		}
	}
};

export default MultipleTabPlugin;

declare module 'vue/types/vue' {
	interface Vue {
		$setOrRemoveData: (route: Route, object: any, module?: number) => Promise<any>;
		$setOrRemoveSearchParameter: (route: Route, object: any, module?: number) => Promise<any>;
		$setOrRemoveCurrentFavourite: (route: Route, module?: number) => Promise<any>;
		$cacheClear: (route: Route) => Promise<any>;
		$getCacheByKey: (route: Route, type?: string) => Promise<any>;
		$setCacheByKey: (route: Route, object: any, type?: string) => Promise<any>;
		$cacheUpdateOrCreate: (route: Route, object: any, module?: number) => Promise<any>;
		$routeVisible: (route: Route) => Promise<Boolean>;
		$removeRoute: (route: Route, index?: number) => Promise<any>;
		$updateCommonVisitedView: (route: Route, module?: string) => void;
		$cacheReset: (module?: string) => void;
		$closeTippy: () => Promise<any>;
		$formatDateTime: () => void;
		$validationAll: () => Promise<any>;
	}
}